"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useContentUploadedSLI = require("./useContentUploadedSLI");
Object.keys(_useContentUploadedSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useContentUploadedSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useContentUploadedSLI[key];
    }
  });
});